<template>
  <div class="ma_home">
    <div class="nav">
      <div class="logo"></div>
    </div>
    <!--按钮-->
    <div class="ma_center">
      <div class="title">日立电梯&nbsp;&nbsp;聚光计划</div>
      <div class="ma_but">
        <div @click="golink" class="pic1"></div>
        <div style="margin-left: 40px" @click="golinks" class="pic2"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {Base64} from "js-base64";
import {getToken, setToken} from "../../utils/auth";
export default {
  name: "ManangeHome",
  methods:{
    golink(){
      this.$router.push('/manageHome')
    },
    golinks(){
      this.$router.push('/manage')
    }
  },
  mounted() {
    //var censhu = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJsb2dpblR5cGUiOiJsb2dpbl9tYW5hZ2VfcXdjb2RlIiwic2NvcGUiOlsiYWxsIl0sImx4VXNlcklkIjoid28wSVZKRHdBQUcxWVp1eVR6N003alVoM3VFNThTeFEiLCJuYW1lIjoi6buE5Lqa5a6BIiwiZXhwIjoxNjczNDIwMTU2LCJ1c2VySWQiOjE5LCJhdXRob3JpdGllcyI6WyJST0xFX21hbmFnZSJdLCJqdGkiOiIxNmZlNGRmZi00ZjJiLTRiZjgtYTVmYi0yYWU4MWUzOTA2ZjIiLCJjbGllbnRfaWQiOiJjbXMtbWFuYWdlIiwidXNlcm5hbWUiOiJ3bzBJVkpEd0FBRzFZWnV5VHo3TTdqVWgzdUU1OFN4USJ9.DZweCQXNFhDHCb9j5FNgdBz5Gqrfjh73OssSMH4WKX4'
    // var url = decodeURIComponent(censhu)
    // var Base64 = require('js-base64').Base64
    // var a = Base64.decode(url);
    // var data = JSON.parse(a)

    // setToken(data.access_token)
     var censhu = location.hash.split("var0=")[1]
       if(censhu || localStorage.getItem('UserAdmin')){
         var url = decodeURIComponent(censhu)
         var Base64 = require('js-base64').Base64
         var a = Base64.decode(url);
         /* Unexpected token '�', "�w^~)�" is not valid JSON */
         try {
           var data = JSON.parse(a)
           console.log(data.accessToken)
           sessionStorage.setItem('userId',data.userId)
           localStorage.setItem('UserAdmin', data.accessToken)
           localStorage.setItem('dialog', 'true')
           // window.location.href = 'https://rl.mxmaker.com/web/#/home'
           this.$router.push('/home')
         } catch (error) {
           console.log('JSON 解析错误:', error.message)
         }
       }else{
         this.$router.push('/login')
       }
  }
}
</script>

<style scoped lang="less">
.nav{
  height: 64px;
  width: 100%;
  align-items: center;
  display: flex;
& > .logo {
    margin-top: 42px;
    margin-left: 208px;
    width:156px;
    height: 48px;
    background: url('~@/assets/imgs/logo@2x.png') no-repeat center
    center / 156px auto;
  }
}
.ma_home{
  background: url('~@/assets/imgs/background_default@2x.png') no-repeat center
    center / 100% 100%;
  min-height: 100vh;
  & > .ma_center{
    color: white;
    & > .title{
      text-align: center;
    }
  }
}
.ma_but{
  display: flex;
  justify-content: center;
  align-items: center;
  & > div{
    cursor : pointer;
    width: 505px;
    height: 300px;
    background: rgba(255,255,255,0.8000);
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    margin-top: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  & >.pic1{
    background: url('~@/assets/imgs/pic1@2x.png') no-repeat center
      center / 505px auto;
  }
  & >.pic2{
    background: url('~@/assets/imgs/pic2@2x.png') no-repeat center
      center / 505px auto;
  }
}
.title{
  padding-top: 110px;
  font-size: 70px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 84px;
  margin: 0 auto;
}
</style>
